var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTag = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "etiqueta-forma-negra",
    width: 15.892,
    height: 15.893,
    viewBox: "0 0 15.892 15.893",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M.39,8.445,7.89.955A3.249,3.249,0,0,1,8.96.278,3.241,3.241,0,0,1,10.188,0h4.364A1.291,1.291,0,0,1,15.5.4a1.29,1.29,0,0,1,.4.944V5.707a3.239,3.239,0,0,1-.278,1.227,3.126,3.126,0,0,1-.677,1.06L7.439,15.5a1.285,1.285,0,0,1-.944.388,1.344,1.344,0,0,1-.955-.388L.39,10.343A1.285,1.285,0,0,1,0,9.4,1.344,1.344,0,0,1,.39,8.445Zm11.2-4.138a1.343,1.343,0,0,0,2.292-.949,1.343,1.343,0,0,0-2.685,0A1.293,1.293,0,0,0,11.588,4.306Z",
    transform: "translate(-0.002 0)",
    fill: "#bebebe"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tag.b3f31db0.svg";
export { ForwardRef as ReactComponent };